module.exports = __webpack_public_path__ + "img/a.ed186522.svg";